import {
  LOCATION_RESPONSE_RECEIVED,
  SET_ACTIVE_LOCATION,
  SET_ACTIVE_LOCATION_WITHOUT_SLOTS,
  LOCATION_FAILED,
  LOCATION_SLOTS_RECEIVED,
  LOCATION_SLOTS_FAILED,
  SET_LOCATION_SOLV_RATINGS,
} from '../constants';
import {
  locationResponseFormatter,
  locationSlotsFormatter,
  publicBookingLocationFormatter,
  locationSolvRatingsFormatter,
} from '../reducers/formatters/location';
import { analyticsTrackEvent } from '../core/analytics';
import { APP_API_FAILURE } from '../core/analytics/events';

function receiveLocation(value) {
  return {
    type: LOCATION_RESPONSE_RECEIVED,
    payload: { value: locationResponseFormatter(value) },
  };
}

function receivePublicBookingLocationData(value) {
  return {
    type: LOCATION_RESPONSE_RECEIVED,
    payload: { value: publicBookingLocationFormatter(value) },
  };
}

function setActiveLocation(value) {
  return {
    type: SET_ACTIVE_LOCATION,
    payload: { value: locationResponseFormatter(value) },
  };
}

function setActiveLocationWithoutSlots(value) {
  return {
    type: SET_ACTIVE_LOCATION_WITHOUT_SLOTS,
    payload: { value: locationResponseFormatter(value) },
  };
}

function locationError(value) {
  analyticsTrackEvent(APP_API_FAILURE);
  return {
    type: LOCATION_FAILED,
    payload: { value },
  };
}

function receiveLocationSlots(value) {
  return {
    type: LOCATION_SLOTS_RECEIVED,
    payload: { value: locationSlotsFormatter(value) },
  };
}

function locationSlotsError(value) {
  analyticsTrackEvent(APP_API_FAILURE);
  return {
    type: LOCATION_SLOTS_FAILED,
    payload: { value },
  };
}

export {
  receiveLocation,
  receiveLocationSlots,
  setActiveLocation,
  setActiveLocationWithoutSlots,
  locationError,
  locationSlotsError,
  receivePublicBookingLocationData,
};
